import Box from "@mui/material/Box";
import { getInitials } from "./UserAvatar.tsx";

interface TenantAvatarProps {
  name: string;
  logoUrl?: string | null;
  size?: number;
}

export function TenantAvatar({ name, logoUrl, size = 32 }: TenantAvatarProps) {
  if (logoUrl) {
    return (
      <Box
        component="img"
        // The API returns the logo endpoint with a version query that changes on
        // every upload, so a new logo is never hidden behind a cached old one.
        src={logoUrl}
        alt={name}
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          objectFit: "cover",
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 1,
        bgcolor: "primary.main",
        color: "primary.contrastText",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.38,
        fontWeight: 700,
        flexShrink: 0,
        lineHeight: 1,
      }}
    >
      {getInitials(name)}
    </Box>
  );
}

export default TenantAvatar;
